import React from 'react';

export default function LinkedSurveysList({ linkedSurveys, onUnlink }) {
    return (
        <div style={{
            marginTop: 12, padding: 10, borderRadius: 6,
            background: '#F8FAFD', border: '1px solid #E8EAED',
        }}>
            {linkedSurveys.length === 0 ? (
                <div style={{ color: '#9AA0A6', fontSize: 12 }}>
                    No surveys linked yet. Drag a deployed survey here.
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {linkedSurveys.map(survey => (
                        <div
                            key={survey.deploymentId}
                            style={{
                                display: 'flex', alignItems: 'center', gap: 8,
                                minHeight: 26, padding: '3px 6px', borderRadius: 4,
                                background: '#fff', border: '1px solid #EEF0F2',
                            }}
                        >
                            <span style={{
                                flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap', color: '#3C4043', fontSize: 12,
                            }}>
                                {survey.surveyName}
                            </span>
                            <button
                                type="button"
                                aria-label={`Unlink ${survey.surveyName}`}
                                title="Unlink"
                                onClick={() => onUnlink?.(survey.deploymentId)}
                                style={{
                                    width: 20, height: 20, border: 'none', borderRadius: 4,
                                    background: 'transparent', color: '#5F6368', cursor: 'pointer',
                                    fontSize: 16, lineHeight: '18px', padding: 0,
                                }}
                            >
                                &times;
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
